<template>
  <div class="w-full relative">
    <div class="mt-6" v-if="isLoading">
      <spinner
        size="medium"
        :spacing="40"
        message=""
        :line-fg-color="$primaryColor"
      />
    </div>
    <div v-else>
      <!-- filter and download -->
      <!-- <div class="absolute z-10 left-0 right-0 top-0 w-full">
        <div class="flex items-center justify-end">
          <div class="flex items-center gap-x-4">
            <el-form>
              <el-form-item>
                <el-input class="w-full" placeholder="Search" v-model="search">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
              </el-form-item>
            </el-form>
            <div class="flex items-center mb-4">
              <div
                class="btn p-1 mr-3.5 pl-2 pr-2 flex items-center justify-center cursor-not-allowed"
              >
                <filter-icon />
                <p class="text-sm font-normal text-root-4 ml-2">Filter</p>
              </div>
              <div
                class="btn p-1 pl-1.5 pr-1.5 flex items-center justify-center cursor-not-allowed"
              >
                <downward-arrow-icon />
                <p class="text-sm font-normal text-root-4 ml-2">Download</p>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <el-table
        class="relative cursor-pointer py-5 font-normal"
        :class="{
          minHeight: noData,
          '-mt-14 py-0': !tenantIsOval,
          'py-5': tenantIsOval
        }"
        index
        :data="tableData"
        style="width: 100%"
        @row-click="showDetails"
      >
        <el-table-column class="w-full" width="80">
          <template slot-scope="scope">
            <div>
              <arrow-down
                v-if="
                  scope.row.transactionType === 'deposit' ||
                  transferType === 'deposit'
                "
              />
              <arrow-up
                v-if="
                  scope.row.transactionType === 'withdrawal' ||
                  transferType === 'withdrawal'
                "
              />
              <terminal-icon
                v-if="tableType === 'terminal' || transferType === 'transfer'"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column class="w-full" width="auto">
          <template slot-scope="scope">
            <div class="font-bold">
              {{ scope.row.name || '-' }}
            </div>
            <div class="text-xs font-normal text-gray-40">
              {{ scope.row.email || '-' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column class="w-full" width="auto">
          <template slot-scope="scope">
            <div class="flex items-center">
              <div class="mb-1 mr-1">
                <red-dot
                  v-if="
                    scope.row.status === $STATUS.FAILED ||
                    scope.row.status === $STATUS.CANCELLED
                  "
                />
                <grey-dot v-if="scope.row.status === $STATUS.INITIATED" />
                <orange-dot v-if="scope.row.status === $STATUS.PROCESSING" />
                <green-dot v-if="scope.row.status === $STATUS.COMPLETED" />
                <yellow-dot v-if="scope.row.status === $STATUS.PENDING" />
              </div>
              <div class="capitalize">{{ scope.row.status }}</div>
            </div>
            <div class="text-xs font-normal capitalize ml-2 text-gray-40">
              {{
                tableType === 'terminal'
                  ? 'Transfer'
                  : scope.row.transactionType || transferType
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column class="w-full" width="auto">
          <template slot-scope="scope">
            <div class="flex">
              <div>
                <currency-icons
                  :currency="getCurrencyCountry(scope.row.currency || currency)"
                />
              </div>
              <div class="uppercase ml-1">
                {{ scope.row.currency || currency }}
              </div>
            </div>
            <div class="text-xs font-normal text-gray-40">
              {{
                tableType === 'terminal' || transferType === 'transfer'
                  ? 'Destination Currency'
                  : 'Currency'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column class="w-full" width="auto">
          <template slot-scope="scope">
            <div>
              {{ $dayjs(scope.row.createdAt).format('DD MMM YY') }}
            </div>
            <div class="text-xs font-normal text-gray-40">
              {{ parseTime(scope.row.createdAt) }}
              {{ $dayjs(scope.row.createdAt).format(' A') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column class="w-full" width="auto">
          <template slot-scope="scope">
            <div style="word-break: break-all">
              {{
                parseMoneyAll(scope.row.amount, scope.row.currency || currency)
              }}
            </div>
            <div class="text-xs font-normal text-gray-40">Amount</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--Pagination-->
    <div class="p-6 grid grid-cols-1 md:justify-items-end">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="page.size"
        @next-click="next"
        @prev-click="prev"
        background
        layout="prev, pager, next"
        :total="page.totalCount"
      >
      </el-pagination>
    </div>
    <!-- dialogs -->
    <external-api-transaction-dialog
      v-if="showExternalTransactionDialog"
      @closeDialog="closeExternalTransactionDialog"
      :showDialog="showExternalTransactionDialog"
      :dialogType="dialogType"
      :transaction="dialogData"
      :transferType="transferType"
    />
    <filter-transaction-dialog
      :showDialog="showFilterDialog"
      @closeDialog="closeFilterDialog"
      :filterType="tableType"
      v-if="showFilterDialog"
    />
    <download-dialog
      :showDialog="showDownloadDialog"
      @closeDialog="closeDownloadDialog"
      v-if="showDownloadDialog"
    />
  </div>
</template>

<script>
import {
  MaskID,
  ParseLocalTime,
  ParseMoneyAll,
  ParseTime,
  GetCurrencyCountry
} from '@/utils/helpers'
import getTreasuryTransactions from '@/mixins/externalApi.js'
import tenant from '@/mixins/tenant.js'
export default {
  name: 'TransactionsTable',
  mixins: [getTreasuryTransactions, tenant],
  data () {
    return {
      dialogData: '',
      dialogType: '',
      search: '',
      showExternalTransactionDialog: false,
      showFilterDialog: false,
      showDownloadDialog: false,
      isLoading: false,
      payload: {
        page: 1,
        size: 10,
        status: '',
        type: '',
        from: '',
        to: ''
      }
    }
  },
  components: {
    ArrowUp: () => import('@/assets/icons/ArrowUp.vue'),
    ArrowDown: () => import('@/assets/icons/ArrowDown.vue'),
    TerminalIcon: () => import('@/assets/icons/TerminalIcon.vue'),
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    GreyDot: () => import('@/assets/icons/GreyDot.vue'),
    OrangeDot: () => import('@/assets/icons/OrangeDot.vue'),
    RedDot: () => import('@/assets/icons/RedDot.vue'),
    GreenDot: () => import('@/assets/icons/GreenDot.vue'),
    YellowDot: () => import('@/assets/icons/YellowDot.vue'),
    FilterTransactionDialog: () =>
      import('@/components/externalApi/dialogs/FilterTransactionDialog.vue'),
    DownloadDialog: () =>
      import('@/components/externalApi/dialogs/DownloadDialog.vue'),
    ExternalApiTransactionDialog: () =>
      import(
        '@/components/externalApi/dialogs/ExternalApiTransactionDialog.vue'
      )
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableType: {
      type: String,
      default: ''
    },
    page: {
      type: Object,
      required: true
    },
    transferType: {
      type: String,
      default: ''
    },
    tableUse: {
      type: String,
      default: ''
    },
    currencySymbol: {
      type: String,
      default: ''
    }
  },
  computed: {
    isTreasury () {
      return (
        this.tableType === 'treasury' ||
        this.transferType === 'withdrawal' ||
        this.transferType === 'deposit'
      )
    },
    isTerminal () {
      return this.tableType === 'terminal' || this.transferType === 'transfer'
    },
    currency () {
      return this.$store.state.externalApi.batchDetails.items?.currency || ''
    },
    noData () {
      return this.tableData.length === 0
    },
    routeDetails () {
      return {
        id: this.$route.params.id,
        status: this.$route.query.status,
        currency: this.$route.query.currency,
        type: this.$route.query.type
      }
    },
    customerId () {
      return this.$route.params.id
    }
  },
  methods: {
    maskID (val) {
      return MaskID(val)
    },
    parseTime (val) {
      return ParseTime(val)
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    parseLocalTime (val) {
      return ParseLocalTime(val)
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    handleCurrentChange (val) {
      this.payload.page = val
      this.isTerminal && this.tableUse === 'transactionHistory'
        ? this.getTerminalTransactions()
        : this.isTreasury && this.tableUse === 'transactionHistory'
        ? this.getTreasuryTransactions()
        : this.tableUse === 'customerDetails' && this.isTerminal
        ? this.getCustomerDetailsTerminalTransactions()
        : this.tableUse === 'customerDetails' && this.isTreasury
        ? this.getCustomerDetailsTreasuryTransactions()
        : this.routeDetails.type === 'withdrawal' ||
          this.routeDetails.type === 'deposit'
        ? this.getTreasuryBatchDetails()
        : this.getBatchDetails()
    },
    next () {
      this.payload.page++
      this.isTerminal
        ? this.getTerminalTransactions()
        : this.isTreasury
        ? this.getTreasuryTransactions()
        : this.tableUse === 'customerDetails' && this.isTerminal
        ? this.getCustomerDetailsTerminalTransactions()
        : this.tableUse === 'customerDetails' && this.isTreasury
        ? this.getCustomerDetailsTreasuryTransactions()
        : this.routeDetails.type === 'withdrawal' ||
          this.routeDetails.type === 'deposit'
        ? this.getTreasuryBatchDetails()
        : this.getBatchDetails()
    },
    prev () {
      this.payload.page--
      this.isTerminal
        ? this.getTerminalTransactions()
        : this.isTreasury
        ? this.getTreasuryTransactions()
        : this.tableUse === 'customerDetails' && this.isTerminal
        ? this.getCustomerDetailsTerminalTransactions()
        : this.tableUse === 'customerDetails' && this.isTreasury
        ? this.getCustomerDetailsTreasuryTransactions()
        : this.routeDetails.type === 'withdrawal' ||
          this.routeDetails.type === 'deposit'
        ? this.getTreasuryBatchDetails()
        : this.getBatchDetails()
    },
    showDetails (row) {
      this.dialogData = row
      this.dialogData.currencySymbol = this.currencySymbol
      this.dialogType = this.tableType
      this.showExternalTransactionDialog = true
    },
    closeExternalTransactionDialog () {
      this.showExternalTransactionDialog = false
    },
    // filter () {
    //   this.showFilterDialog = true
    // },
    // download () {
    //   this.showDownloadDialog = true
    // },
    closeFilterDialog () {
      this.showFilterDialog = false
    },
    closeDownloadDialog () {
      this.showDownloadDialog = false
    }
  }
}
</script>
<style scoped>
>>> .el-table th {
  background: var(--background);
  border: none;
}
>>> .el-table tr {
  background: var(--background);
}
>>> .el-table th.el-table__cell > .cell {
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}
.btn {
  background: rgba(1, 5, 44, 0.05);
  border: 0.719333px solid #c1c4ca;
  border-radius: 6px;
}
>>> .el-pagination.is-background .btn-next.disabled,
.el-pagination.is-background .btn-next:disabled,
.el-pagination.is-background .btn-prev.disabled,
.el-pagination.is-background .btn-prev:disabled,
.el-pagination.is-background .el-pager li.disabled {
  background: green !important;
}
>>> .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: var(--background-2) !important;
}
>>> li.number.active {
  background-color: var(--background) !important;
  border: 0.5px solid var(--color-primary) !important;
  box-sizing: border-box;
  border-radius: 100px;
  font-weight: 400;
  color: var(--color-primary) !important ;
}
>>> li.number {
  background-color: var(--background) !important;
  border: 0.5px solid var(--text-1) !important;
  box-sizing: border-box;
  border-radius: 100px !important;
  font-weight: 400;
  /* color: var(--color-primary) !important ; */
}
.minHeight {
  height: 30vh;
}
</style>
